import {
  Banner,
  Services,
  Destination,
  Packages,
  Visit,
  Reviews,
  Cta,
  Footer,
} from "./components";

function App() {
  return (
    <>
      <Banner />
      <Services />
      <Destination />
      <Packages />
      <Visit />
      <Reviews />
      <Cta />
      <Footer />
    </>
  );
}

export default App;
